import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../../brand';
import {
  PRINT_BRAND_FONT_FAMILY,
  PRINT_DARK_DIVIDER,
  PRINT_FONT_SIZE,
  PRINT_IMAGE_COLUMN_WIDTH,
  PRINT_PADDING_X,
  darkCellSx,
  labelTypographySx,
} from './printStyles';

interface JobOrderHeaderProps {
  dueDate: string;
  quantity: number;
}

const HeaderSegment = ({
  label,
  divider = false,
  children,
}: {
  label?: string;
  divider?: boolean;
  children: ReactNode;
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      px: PRINT_PADDING_X * 1.5,
      borderLeft: divider ? PRINT_DARK_DIVIDER : 'none',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, minWidth: 0 }}>
      {label ? (
        <Typography
          sx={{
            ...labelTypographySx,
            fontSize: PRINT_FONT_SIZE.headerLabel,
            opacity: 0.75,
            flexShrink: 0,
          }}
        >
          {label}
        </Typography>
      ) : null}
      {children}
    </Box>
  </Box>
);

const headerValueSx = {
  fontWeight: 700,
  lineHeight: 1.1,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
} as const;

const JobOrderHeader = ({ dueDate, quantity }: JobOrderHeaderProps) => (
  <Box
    sx={{
      ...darkCellSx,
      display: 'grid',
      gridTemplateColumns: `minmax(0, 1fr) ${PRINT_IMAGE_COLUMN_WIDTH}px`,
      alignItems: 'stretch',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', py: 1.5 }}>
      <HeaderSegment>
        <Box
          component="span"
          sx={{
            ...headerValueSx,
            fontSize: PRINT_FONT_SIZE.headerTitle,
            fontFamily: PRINT_BRAND_FONT_FAMILY,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          {BRAND.name} Job Order
        </Box>
      </HeaderSegment>
    </Box>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) max-content',
        py: 1.5,
      }}
    >
      <HeaderSegment label="Due" divider>
        <Typography
          sx={{ ...headerValueSx, fontSize: PRINT_FONT_SIZE.headerDate }}
        >
          {dueDate}
        </Typography>
      </HeaderSegment>
      <HeaderSegment label="Qty" divider>
        <Typography
          sx={{ ...headerValueSx, fontSize: PRINT_FONT_SIZE.headerQuantity }}
        >
          {quantity}
        </Typography>
      </HeaderSegment>
    </Box>
  </Box>
);

export default JobOrderHeader;
